import Language from "./Language";

const translation = {
	en: {
		"Stack Technique": "Technical Stack",
		"Expériences": "Experiences",
		"Projets": "Projects",
		"ans d'expériences": "years of experience",
		"du plus récent au plus ancien": "from newest to oldest"
	}
}

export default function Translation(label) {
	const language = Language(["fr", "en"])

	return translation[language.use] && translation[language.use][label] || label
}